import { format } from "date-fns";
import React from "react";

interface Result {
  title: string;
  authors?: string[];
  concepts?: string[];
  publication_date?: string;
  open_access?: boolean;
  doi?: string;
  url?: string;
  id?: string;
}

interface ListViewProps {
  results: Result[];
  onSelectStudy: (paperId: string | undefined) => void;
  onBookmarkPaper: (paper: Result) => void;
  isAuthenticated: boolean;
}

// Extract the last part of the url which is the OpenAlex Id
const extractOpenAlexId = (url: string | undefined): string | undefined => {
  return url ? url.split("/").pop() : undefined;
};

const ListView: React.FC<ListViewProps> = ({
  results,
  onSelectStudy,
  onBookmarkPaper,
  isAuthenticated,
}) => {
  return (
    <div className="w-full px-4 mt-4">
      <ul className="space-y-4 pr-2">
        {results.map((result, index) => (
          <li key={index} className="border-b border-gray-200 pb-4">
            <div className="grid grid-cols-12">
              <h3
                className="text-md font-bold col-span-9 cursor-pointer hover:underline transition duration-200"
                onClick={() => onSelectStudy(extractOpenAlexId(result.url))}
              >
                {result.title}
              </h3>
              <div className="text-right me-5 col-span-3 flex justify-end items-center space-x-3">
                {isAuthenticated && (
                  <button
                    onClick={() => onBookmarkPaper(result)}
                    className="text-sm text-blue-500 hover:text-blue-700"
                    title="Bookmark this paper"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
                    </svg>
                  </button>
                )}
                {result.doi && (
                  <a
                    href={result.doi}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-accent font-medium hover:underline"
                  >
                    View DOI
                  </a>
                )}
              </div>
            </div>
            <p className="text-accent text-sm">
              {result.authors?.join(", ") || "Unknown Authors"}
            </p>
            <p className="text-neutral font-light text-sm">
              {result.publication_date
                ? format(new Date(result.publication_date), "do MMMM yyyy")
                : "Unknown Date"}
            </p>
            {(result.concepts?.length ?? 0) > 0 && (
              <div className="flex flex-wrap gap-1 py-3">
                {result.concepts?.map((concept, index) => (
                  <div
                    key={index}
                    className="bg-neutral rounded-lg text-xs px-2 py-1 text-white font-medium"
                  >
                    {concept}
                  </div>
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ListView;
